module.exports = __webpack_public_path__ + "static/media/header_item7f2f3c4377cc45332b583632a3e4d56b.webp";